import { useState } from "react";
import { useTranslation } from "react-i18next";

export const RequestCallback = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null
  const [loading, setLoading] = useState(false);

  // Formspree endpoint
  const FORMSPREE_URL = "https://formspree.io/f/mpqjpoqa"

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const formData = new FormData(e.target);

    try {
      const response = await fetch(FORMSPREE_URL, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
        console.error(data);
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(true)}
        className="
          fixed bottom-24 right-4 z-50
          w-14 h-14
          flex items-center justify-center
          rounded-full
          bg-gradient-to-r from-blue-600 to-indigo-600
          shadow-lg
          hover:scale-110
          transition-all duration-300
        "
        aria-label="Request Call"
      >
        📞
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6 relative animate-fadeIn">
            
            {/* Close */}
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
            >
              ✕
            </button>

            <h2 className="text-2xl font-bold mb-4 text-blue-900">
              {t("callback.title")}
            </h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium mb-1">
                  {t("callback.name")}
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder={t("callback.namePlaceholder")}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  {t("callback.phone")}
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder={t("callback.phonePlaceholder")}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  {t("callback.message")}
                </label>
                <textarea
                  name="message"
                  rows="3"
                  required
                  className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder={t("callback.messagePlaceholder")}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`
                  w-full
                  bg-gradient-to-r from-blue-600 to-indigo-600
                  text-white font-semibold
                  py-2 rounded-lg
                  hover:opacity-90 transition
                  ${loading ? "opacity-70 cursor-not-allowed" : ""}
                `}
              >
                {loading ? "..." : t("callback.submit")}
              </button>

              {/* Feedback Message */}
              {status === "success" && (
                <p className="mt-2 text-green-600 font-semibold text-center">
                  {t("callback.success")}
                </p>
              )}
              {status === "error" && (
                <p className="mt-2 text-red-600 font-semibold text-center">
                  {t("callback.error")}
                </p>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
}

